import React from 'react';
import InternshipTimeLine from './InternshipTimeLine';
import { BiArrowBack } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import WorkProjects from './WorkProjects';

const Experience = () => {
    return (
        <div className='container'>
            <Link to="/">
                <div className="grid justify-center py-4 h1p sticky top-0 z-[50]">
                    <button type="button" class="bg-gray-800 text-white rounded-r-md py-2 border-l border-gray-200 hover:bg-primary hover:text-white px-3">
                        <div class="flex flex-row align-middle">
                            <span class="mr-2">Let's  Home Page </span>
                            <svg class="w-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                            </svg>
                        </div>
                    </button>
                </div>
            </Link>
           <InternshipTimeLine/> 
           <WorkProjects/>
        </div>
    );
};

export default Experience;